<ng-container *ngIf="entityType == 'EKAMPUS'">
  <app-headerEkampus></app-headerEkampus>
</ng-container>
<ng-container *ngIf="entityType == 'IP'">
  <app-headerIP></app-headerIP>
</ng-container>
